import { Component } from "@angular/core";
import {
  GloTabContentDirective,
  GloTabsComponent,
  TabItem,
} from "../../../shared/components/tabs/tabs.component";

import { BusinessAccountPasswordComponent } from "./password/password.component";
import { BusinessAccountBillingComponent } from "./billing/billing.component";
import { BusinessAccountNotificationComponent } from "./notification/notification.component";
import { BusinessAccountDetailsComponent } from "./details/details.component";
import { BusinessAccountPermissionsComponent } from "../account/permissions/permissions.component";
import { BusinessAccountStoreComponent } from "./store/store.component";
import { BusinessAccountIntegrationsComponent } from "./integrations/integrations.component";
import { environment } from "../../../../environments/environment";

@Component({
  selector: "business-account-store-settings",
  standalone: true,
  imports: [
    GloTabsComponent,
    GloTabContentDirective,
    BusinessAccountPasswordComponent,
    BusinessAccountBillingComponent,
    BusinessAccountNotificationComponent,
    BusinessAccountDetailsComponent,
    BusinessAccountPermissionsComponent,
    BusinessAccountStoreComponent,
    BusinessAccountIntegrationsComponent,
  ],
  templateUrl: "./account-store-settings.component.html",
  styleUrl: "./account-store-settings.component.scss",
})
export class BusinessAccountStoreSettingsComponent {
  assetUrl = environment.assetBaseUrl;

  tabs: TabItem[] = [
    { label: "My Details", key: "details" },
    { label: "Store", key: "store" },
    { label: "Permissions", key: "permissions" },
    { label: "Password", key: "password" },
    { label: "Billing", key: "billing" },
    { label: "Integrations", key: "integrations" },
    { label: "Notifications", key: "notification" },
  ];
}
